// Polyfill for Node.js globals in browser environment
if (typeof window !== 'undefined') {
  // Polyfill global
  if (typeof (window as any).global === 'undefined') {
    (window as any).global = window;
  }

  // Polyfill process
  if (typeof (window as any).process === 'undefined') {
    (window as any).process = {
      env: {
        NODE_ENV: 'development'
      },
      browser: true,
      version: '',
      versions: {}
    };
  }

  // Polyfill Buffer
  if (typeof (window as any).Buffer === 'undefined') {
    (window as any).Buffer = {
      isBuffer: () => false
    };
  }

  // Polyfill setImmediate
  if (typeof (window as any).setImmediate === 'undefined') {
    (window as any).setImmediate = setTimeout;
  }

  // Polyfill clearImmediate
  if (typeof (window as any).clearImmediate === 'undefined') {
    (window as any).clearImmediate = clearTimeout;
  }
}

// Export an empty object to ensure the file is treated as a module
export {}; 